module.exports = __webpack_public_path__ + "img/kg1.1934dd4c.png";